/**
 * V70G8G — 엔글 룰렛 진행자 판정 (메뉴 노출과 페이지 접근의 단일 기준)
 *
 * 정책: 게임대회 접근(TournamentAccessGuard / useMyTournamentAccess) + system_admin 역할 직접 보유.
 *   - 관리자급 역할(role_admin_kr / role_admin_cn)은 진행자로 보지 않는다.
 *     (rbac.hasRole 은 관리자급을 모든 역할 보유로 간주하므로 여기서는 사용하지 않는다)
 *   - 역할 로딩 전(roles 없음)에는 false — 메뉴가 잠깐 노출되지 않게 한다.
 */
export const ROULETTE_PATH = '/tournament/roulette';

export function canHostRoulette(roles: readonly string[] | null | undefined): boolean {
  return Array.isArray(roles) && roles.includes('system_admin');
}
